<template>
    <bo-popup-modal
        id="new_address_modal"
        :title="modalTitle"
        action="Confirm"
        modal-style="full-width has-table"
        :active="showNewAddressPopup"
        :keep-alive="true"
        @deactivate="$emit('deactivate')"
        @trigger="triggerAction"
    >
        <template #body-content>
            <div class="table-content">
                <div class="col-12 mt-2 mb-2 py-0">
                    <!-- Taiwan address format -->
                    <div
                        v-if="siteCurrency == 'TWD'"
                        class="row frame-body"
                        style="gap: 8px 0"
                    >
                        <div
                            class="col-12 col-lg-6 col-xl-4"
                            style="display: block"
                        >
                            <div class="form-group">
                                <div class="label-group">
                                    <div class="label-tooltip">
                                        <label
                                            id="shipping_address_name_label"
                                            :class="{
                                                required: mandatoryFields?.label != null,
                                            }"
                                        >
                                            {{ accountTranslations.shipping_name }}
                                        </label>
                                    </div>
                                </div>
                                <div class="input-error-group">
                                    <input
                                        id="shipping_address_name"
                                        v-model="newAddress['label']"
                                        type="text"
                                        maxlength="190"
                                        class="form-control"
                                    />
                                    <div
                                        class="text-danger form-error"
                                        v-if="errors['shipping_address_label']"
                                    >
                                        <i class="icon-cancelcircle-1"></i>
                                        {{ errors["shipping_address_label"] }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            class="col-12 col-lg-6 col-xl-4"
                            style="display: block"
                        >
                            <div
                                v-if="deprecatedCompanyFieldEnabled || showPhoneInAddress"
                                class="form-group"
                            >
                                <div class="label-group">
                                    <div class="label-tooltip">
                                        <label
                                            id="shipping_phone_label"
                                            :class="{
                                                required: mandatoryFields?.phone != null,
                                            }"
                                        >
                                            {{ accountTranslations.shipping_phone }}
                                        </label>
                                    </div>
                                </div>
                                <div class="input-error-group">
                                    <input
                                        id="shipping_phone"
                                        v-model="newAddress['phone']"
                                        type="text"
                                        maxlength="190"
                                        class="form-control"
                                    />
                                    <div
                                        class="text-danger form-error"
                                        v-if="errors['shipping_address_phone']"
                                    >
                                        <i class="icon-cancelcircle-1"></i>
                                        {{ errors["shipping_address_phone"] }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            class="col-12 col-lg-6 col-xl-4"
                            style="display: block"
                        >
                            <div
                                v-if="deprecatedCompanyFieldEnabled"
                                class="form-group"
                            >
                                <div class="label-group">
                                    <div class="label-tooltip">
                                        <label
                                            id="shipping_email_label"
                                            :class="{
                                                required: mandatoryFields?.email != null,
                                            }"
                                        >
                                            {{ accountTranslations.shipping_email }}
                                        </label>
                                    </div>
                                </div>
                                <div class="input-error-group">
                                    <input
                                        id="shipping_email"
                                        v-model="newAddress['email']"
                                        type="text"
                                        maxlength="190"
                                        class="form-control"
                                    />
                                    <div
                                        class="text-danger form-error"
                                        v-if="errors['shipping_address_email']"
                                    >
                                        <i class="icon-cancelcircle-1"></i>
                                        {{ errors["shipping_address_email"] }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-lg-6 col-xl-3">
                            <div class="form-group">
                                <div class="label-group">
                                    <div class="label-tooltip">
                                        <label
                                            id="shipping_address_postcode_label"
                                            :class="{
                                                required: mandatoryFields?.postcode != null,
                                            }"
                                        >
                                            {{ accountTranslations.postcode }}
                                        </label>
                                    </div>
                                </div>
                                <div class="input-error-group">
                                    <div class="">
                                        <input
                                            id="shipping_address_postcode"
                                            v-model="newAddress['postcode']"
                                            type="text"
                                            maxlength="190"
                                            class="form-control"
                                        />
                                        <div
                                            class="text-danger form-error"
                                            v-if="errors['shipping_address_postcode']"
                                        >
                                            <i class="icon-cancelcircle-1"></i>
                                            {{ errors["shipping_address_postcode"] }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-lg-6 col-xl-3">
                            <div class="form-group">
                                <div class="label-group">
                                    <div class="label-tooltip">
                                        <label
                                            id="shipping_address_country_label"
                                            :class="{
                                                required: mandatoryFields?.country != null,
                                            }"
                                        >
                                            {{ accountTranslations.country }}
                                        </label>
                                    </div>
                                </div>
                                <div class="input-error-group">
                                    <div class="">
                                        <input
                                            id="shipping_address_country"
                                            v-model="newAddress['country']"
                                            type="text"
                                            maxlength="190"
                                            class="form-control"
                                        />
                                        <div
                                            class="text-danger form-error"
                                            v-if="errors['shipping_address_country']"
                                        >
                                            <i class="icon-cancelcircle-1"></i>
                                            {{ errors["shipping_address_country"] }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-lg-6 col-xl-3">
                            <div class="form-group">
                                <div class="label-group">
                                    <div class="label-tooltip">
                                        <label
                                            id="shipping_address_state_label"
                                            :class="{
                                                required: mandatoryFields?.state != null,
                                            }"
                                        >
                                            {{ accountTranslations.state }}
                                        </label>
                                    </div>
                                </div>
                                <div class="input-error-group">
                                    <div class="">
                                        <input
                                            id="shipping_address_state"
                                            v-model="newAddress['state']"
                                            type="text"
                                            maxlength="190"
                                            class="form-control"
                                        />
                                        <div
                                            class="text-danger form-error"
                                            v-if="errors['shipping_address_state']"
                                        >
                                            <i class="icon-cancelcircle-1"></i>
                                            {{ errors["shipping_address_state"] }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-lg-6 col-xl-3">
                            <div class="form-group">
                                <div class="label-group">
                                    <div class="label-tooltip">
                                        <label
                                            id="shipping_address_city_label"
                                            :class="{
                                                required: mandatoryFields?.city != null,
                                            }"
                                        >
                                            {{ accountTranslations.city }}
                                        </label>
                                    </div>
                                </div>
                                <div class="input-error-group">
                                    <div class="">
                                        <input
                                            id="shipping_address_city"
                                            v-model="newAddress['city']"
                                            type="text"
                                            maxlength="190"
                                            class="form-control"
                                        />
                                        <div
                                            class="text-danger form-error"
                                            v-if="errors['shipping_address_city']"
                                        >
                                            <i class="icon-cancelcircle-1"></i>
                                            {{ errors["shipping_address_city"] }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-xl-6">
                            <div class="form-group">
                                <div class="label-group">
                                    <div class="label-tooltip">
                                        <label
                                            id="shipping_address_address_1_label"
                                            :class="{
                                                required: mandatoryFields?.address_1 != null,
                                            }"
                                        >
                                            {{ accountTranslations.shipping_address1 }}
                                        </label>
                                    </div>
                                </div>
                                <div class="input-error-group">
                                    <div class="">
                                        <input
                                            id="shipping_address_address_1"
                                            v-model="newAddress['address_1']"
                                            type="text"
                                            maxlength="190"
                                            class="form-control"
                                        />
                                        <div
                                            class="text-danger form-error"
                                            v-if="errors['shipping_address_address_1']"
                                        >
                                            <i class="icon-cancelcircle-1"></i>
                                            {{ errors["shipping_address_address_1"] }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-xl-6">
                            <div class="form-group">
                                <div class="label-group">
                                    <div class="label-tooltip">
                                        <label
                                            id="shipping_address_address_2_label"
                                            :class="{
                                                required: mandatoryFields?.address_2 != null,
                                            }"
                                        >
                                            {{ accountTranslations.shipping_address2 }}
                                        </label>
                                    </div>
                                </div>
                                <div class="input-error-group">
                                    <div class="">
                                        <input
                                            id="shipping_address_address_2"
                                            v-model="newAddress['address_2']"
                                            type="text"
                                            maxlength="190"
                                            class="form-control"
                                        />
                                        <div
                                            class="text-danger form-error"
                                            v-if="errors['shipping_address_address_2']"
                                        >
                                            <i class="icon-cancelcircle-1"></i>
                                            {{ errors["shipping_address_address_2"] }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            class="col-12 col-lg-6 col-xl-3"
                            style="display: block"
                        >
                            <div class="form-group">
                                <div class="label-group">
                                    <div class="label-tooltip">
                                        <label
                                            id="shipping_address_remark_label"
                                            :class="{
                                                required: mandatoryFields?.remark != null,
                                            }"
                                        >
                                            {{ translations.remark }}
                                        </label>
                                    </div>
                                </div>
                                <div class="input-error-group">
                                    <input
                                        id="shipping_address_remark"
                                        v-model="newAddress['remark']"
                                        type="text"
                                        maxlength="190"
                                        class="form-control"
                                    />
                                    <div
                                        class="text-danger form-error"
                                        v-if="errors['shipping_address_remark']"
                                    >
                                        <i class="icon-cancelcircle-1"></i>
                                        {{ errors["shipping_address_remark"] }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- CUSTOM FIELD -->
                        <div
                            v-for="(field, key) in customFields"
                            :key="key"
                            class="col-12 col-lg-6 col-xl-4"
                            style="display: block"
                        >
                            <div class="form-group">
                                <div class="label-group">
                                    <div class="label-tooltip">
                                        <label
                                            :id="'shipping_address_custom_field_' + field.slug + '_label'"
                                            :class="[{ required: mandatoryCustomFields }]"
                                        >
                                            {{ field.label }}
                                        </label>
                                    </div>
                                </div>
                                <div
                                    v-if="field.type === 'select'"
                                    class="input-error-group"
                                >
                                    <select
                                        v-model="newAddressCustomFields[field.slug]"
                                        :id="'shipping_address_custom_field_' + field.slug"
                                        class="form-control"
                                    >
                                        <option
                                            v-for="(option, i) in field.options"
                                            :key="i"
                                            :value="option.value"
                                        >
                                            {{ option.label }}
                                        </option>
                                    </select>
                                    <div
                                        class="text-danger form-error"
                                        v-if="errors[field.slug]"
                                    >
                                        <i class="icon-cancelcircle-1"></i>
                                        {{ errors[field.slug] }}
                                    </div>
                                </div>
                                <div
                                    v-else
                                    class="input-error-group"
                                >
                                    <input
                                        v-model="newAddressCustomFields[field.slug]"
                                        :id="'shipping_address_custom_field_' + field.slug"
                                        type="text"
                                        maxlength="190"
                                        class="form-control"
                                    />
                                    <div
                                        class="text-danger form-error"
                                        v-if="errors[field.slug]"
                                    >
                                        <i class="icon-cancelcircle-1"></i>
                                        {{ errors[field.slug] }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- By default Malaysia format -->
                    <div
                        v-else
                        class="row frame-body"
                        style="gap: 8px 0"
                    >
                        <div
                            class="col-12 col-lg-6 col-xl-4"
                            style="display: block"
                        >
                            <div class="form-group">
                                <div class="label-group">
                                    <div class="label-tooltip">
                                        <label
                                            id="shipping_address_name_label"
                                            :class="{
                                                required: mandatoryFields?.label != null,
                                            }"
                                        >
                                            {{ accountTranslations.shipping_name }}
                                        </label>
                                    </div>
                                </div>
                                <div class="input-error-group">
                                    <input
                                        id="shipping_address_name"
                                        v-model="newAddress['label']"
                                        type="text"
                                        maxlength="190"
                                        class="form-control"
                                    />
                                    <div
                                        class="text-danger form-error"
                                        v-if="errors['shipping_address_label']"
                                    >
                                        <i class="icon-cancelcircle-1"></i>
                                        {{ errors["shipping_address_label"] }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            class="col-12 col-lg-6 col-xl-4"
                            style="display: block"
                        >
                            <div
                                v-if="deprecatedCompanyFieldEnabled || showPhoneInAddress"
                                class="form-group"
                            >
                                <div class="label-group">
                                    <div class="label-tooltip">
                                        <label
                                            id="shipping_phone_label"
                                            :class="{
                                                required: mandatoryFields?.phone != null,
                                            }"
                                        >
                                            {{ accountTranslations.shipping_phone }}
                                        </label>
                                    </div>
                                </div>
                                <div class="input-error-group">
                                    <input
                                        id="shipping_phone"
                                        v-model="newAddress['phone']"
                                        type="text"
                                        maxlength="190"
                                        class="form-control"
                                    />
                                    <div
                                        class="text-danger form-error"
                                        v-if="errors['shipping_address_phone']"
                                    >
                                        <i class="icon-cancelcircle-1"></i>
                                        {{ errors["shipping_address_phone"] }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            class="col-12 col-lg-6 col-xl-4"
                            style="display: block"
                        >
                            <div
                                v-if="deprecatedCompanyFieldEnabled"
                                class="form-group"
                            >
                                <div class="label-group">
                                    <div class="label-tooltip">
                                        <label
                                            id="shipping_email_label"
                                            :class="{
                                                required: mandatoryFields?.email != null,
                                            }"
                                        >
                                            {{ accountTranslations.shipping_email }}
                                        </label>
                                    </div>
                                </div>
                                <div class="input-error-group">
                                    <input
                                        id="shipping_email"
                                        v-model="newAddress['email']"
                                        type="text"
                                        maxlength="190"
                                        class="form-control"
                                    />
                                    <div
                                        class="text-danger form-error"
                                        v-if="errors['shipping_address_email']"
                                    >
                                        <i class="icon-cancelcircle-1"></i>
                                        {{ errors["shipping_address_email"] }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-xl-6">
                            <div class="form-group">
                                <div class="label-group">
                                    <div class="label-tooltip">
                                        <label
                                            id="shipping_address_address_1_label"
                                            :class="{
                                                required: mandatoryFields?.address_1 != null,
                                            }"
                                        >
                                            {{ accountTranslations.shipping_address1 }}
                                        </label>
                                    </div>
                                </div>
                                <div class="input-error-group">
                                    <div class="">
                                        <input
                                            id="shipping_address_address_1"
                                            v-model="newAddress['address_1']"
                                            type="text"
                                            maxlength="190"
                                            class="form-control"
                                        />
                                        <div
                                            class="text-danger form-error"
                                            v-if="errors['shipping_address_address_1']"
                                        >
                                            <i class="icon-cancelcircle-1"></i>
                                            {{ errors["shipping_address_address_1"] }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-xl-6">
                            <div class="form-group">
                                <div class="label-group">
                                    <div class="label-tooltip">
                                        <label
                                            id="shipping_address_address_2_label"
                                            :class="{
                                                required: mandatoryFields?.address_2 != null,
                                            }"
                                        >
                                            {{ accountTranslations.shipping_address2 }}
                                        </label>
                                    </div>
                                </div>
                                <div class="input-error-group">
                                    <div class="">
                                        <input
                                            id="shipping_address_address_2"
                                            v-model="newAddress['address_2']"
                                            type="text"
                                            maxlength="190"
                                            class="form-control"
                                        />
                                        <div
                                            class="text-danger form-error"
                                            v-if="errors['shipping_address_address_2']"
                                        >
                                            <i class="icon-cancelcircle-1"></i>
                                            {{ errors["shipping_address_address_2"] }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-lg-6 col-xl-3">
                            <div class="form-group">
                                <div class="label-group">
                                    <div class="label-tooltip">
                                        <label
                                            id="shipping_address_postcode_label"
                                            :class="{
                                                required: mandatoryFields?.postcode != null,
                                            }"
                                        >
                                            {{ accountTranslations.postcode }}
                                        </label>
                                    </div>
                                </div>
                                <div class="input-error-group">
                                    <div class="">
                                        <input
                                            id="shipping_address_postcode"
                                            v-model="newAddress['postcode']"
                                            type="text"
                                            maxlength="190"
                                            class="form-control"
                                        />
                                        <div
                                            class="text-danger form-error"
                                            v-if="errors['shipping_address_postcode']"
                                        >
                                            <i class="icon-cancelcircle-1"></i>
                                            {{ errors["shipping_address_postcode"] }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-lg-6 col-xl-3">
                            <div class="form-group">
                                <div class="label-group">
                                    <div class="label-tooltip">
                                        <label
                                            id="shipping_address_city_label"
                                            :class="{
                                                required: mandatoryFields?.city != null,
                                            }"
                                        >
                                            {{ accountTranslations.city }}
                                        </label>
                                    </div>
                                </div>
                                <div class="input-error-group">
                                    <div class="">
                                        <input
                                            id="shipping_address_city"
                                            v-model="newAddress['city']"
                                            type="text"
                                            maxlength="190"
                                            class="form-control"
                                        />
                                        <div
                                            class="text-danger form-error"
                                            v-if="errors['shipping_address_city']"
                                        >
                                            <i class="icon-cancelcircle-1"></i>
                                            {{ errors["shipping_address_city"] }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-lg-6 col-xl-3">
                            <div class="form-group">
                                <div class="label-group">
                                    <div class="label-tooltip">
                                        <label
                                            id="shipping_address_state_label"
                                            :class="{
                                                required: mandatoryFields?.state != null,
                                            }"
                                        >
                                            {{ accountTranslations.state }}
                                        </label>
                                    </div>
                                </div>
                                <div class="input-error-group">
                                    <div class="">
                                        <input
                                            id="shipping_address_state"
                                            v-model="newAddress['state']"
                                            type="text"
                                            maxlength="190"
                                            class="form-control"
                                        />
                                        <div
                                            class="text-danger form-error"
                                            v-if="errors['shipping_address_state']"
                                        >
                                            <i class="icon-cancelcircle-1"></i>
                                            {{ errors["shipping_address_state"] }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-lg-6 col-xl-3">
                            <div class="form-group">
                                <div class="label-group">
                                    <div class="label-tooltip">
                                        <label
                                            id="shipping_address_country_label"
                                            :class="{
                                                required: mandatoryFields?.country != null,
                                            }"
                                        >
                                            {{ accountTranslations.country }}
                                        </label>
                                    </div>
                                </div>
                                <div class="input-error-group">
                                    <div class="">
                                        <input
                                            id="shipping_address_country"
                                            v-model="newAddress['country']"
                                            type="text"
                                            maxlength="190"
                                            class="form-control"
                                        />
                                        <div
                                            class="text-danger form-error"
                                            v-if="errors['shipping_address_country']"
                                        >
                                            <i class="icon-cancelcircle-1"></i>
                                            {{ errors["shipping_address_country"] }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            class="col-12 col-lg-6 col-xl-3"
                            style="display: block"
                        >
                            <div class="form-group">
                                <div class="label-group">
                                    <div class="label-tooltip">
                                        <label
                                            id="shipping_address_remark_label"
                                            :class="{
                                                required: mandatoryFields?.remark != null,
                                            }"
                                        >
                                            {{ translations.remark }}
                                        </label>
                                    </div>
                                </div>
                                <div class="input-error-group">
                                    <input
                                        id="shipping_address_remark"
                                        v-model="newAddress['remark']"
                                        type="text"
                                        maxlength="190"
                                        class="form-control"
                                    />
                                    <div
                                        class="text-danger form-error"
                                        v-if="errors['shipping_address_remark']"
                                    >
                                        <i class="icon-cancelcircle-1"></i>
                                        {{ errors["shipping_address_remark"] }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- CUSTOM FIELD -->
                        <div
                            v-for="(field, key) in customFields"
                            :key="key"
                            class="col-12 col-lg-6 col-xl-4"
                            style="display: block"
                        >
                            <div class="form-group">
                                <div class="label-group">
                                    <div class="label-tooltip">
                                        <label
                                            :id="'shipping_address_custom_field_' + field.slug + '_label'"
                                            :class="[{ required: mandatoryCustomFields }]"
                                        >
                                            {{ field.label }}
                                        </label>
                                    </div>
                                </div>
                                <div
                                    v-if="field.type === 'select'"
                                    class="input-error-group"
                                >
                                    <select
                                        v-model="newAddressCustomFields[field.slug]"
                                        :id="'shipping_address_custom_field_' + field.slug"
                                        class="form-control"
                                    >
                                        <option
                                            v-for="(option, i) in field.options"
                                            :key="i"
                                            :value="option.value"
                                        >
                                            {{ option.label }}
                                        </option>
                                    </select>
                                    <div
                                        class="text-danger form-error"
                                        v-if="errors[field.slug]"
                                    >
                                        <i class="icon-cancelcircle-1"></i>
                                        {{ errors[field.slug] }}
                                    </div>
                                </div>
                                <div
                                    v-else
                                    class="input-error-group"
                                >
                                    <input
                                        v-model="newAddressCustomFields[field.slug]"
                                        :id="'shipping_address_custom_field_' + field.slug"
                                        type="text"
                                        maxlength="190"
                                        class="form-control"
                                    />
                                    <div
                                        class="text-danger form-error"
                                        v-if="errors[field.slug]"
                                    >
                                        <i class="icon-cancelcircle-1"></i>
                                        {{ errors[field.slug] }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </bo-popup-modal>
</template>

<script>
export default {
    props: {
        showNewAddressPopup: {
            type: Boolean,
            default: false,
        },
        existingAddress: {
            type: Object,
            default: () => ({}),
        },
        translations: {
            type: Object,
            default: () => ({}),
        },
        generalTranslations: {
            type: Object,
            default: () => ({}),
        },
        // Normally an object indexed by slug - that is what every call site builds (the cart pages
        // key window.bo.shippingAddressCustomFields by slug themselves, the document page receives
        // an already keyBy'd collection). An array is also accepted because keyBy on an empty
        // collection serialises to [] rather than {}, so a site with no custom fields configured
        // passes an array. The component reads field.slug and Object.values, so either shape works.
        customFields: {
            type: [Array, Object],
            default: () => ({}),
        },
        deprecatedCompanyFieldEnabled: {
            type: Boolean,
            default: false,
        },
        showPhoneInAddress: {
            type: Boolean,
            default: false,
        },
        siteCurrency: {
            type: String,
            default: "MYR",
        },
    },
    data() {
        return {
            newAddress: {
                label: "",
                phone: "",
                email: "",
                address_1: "",
                address_2: "",
                country: "",
                state: "",
                city: "",
                postcode: "",
                remark: "",
            },
            newAddressCustomFields: {},
            errors: {},
            mandatoryFields: window.bo.mandatoryFields,
            mandatoryCustomFields: window.bo.mandatoryCustomFields,
            accountTranslations: window?.bo?.accountTranslations ?? null,
        };
    },
    computed: {
        modalTitle() {
            const hasAddress = this.existingAddress && Object.keys(this.existingAddress).length > 0;

            return hasAddress
                ? this.translations.update_shipping_address
                : this.translations.create_new_shipping_address;
        },
    },
    watch: {
        showNewAddressPopup(newValue) {
            if (newValue) {
                if (Object.keys(this.existingAddress).length === 0) {
                    // new address
                    this.resetVariables();
                } else {
                    this.newAddress = {
                        label: this.existingAddress.label,
                        phone: this.existingAddress.phone,
                        email: this.existingAddress.email,
                        address_1: this.existingAddress.address_1,
                        address_2: this.existingAddress.address_2,
                        country: this.existingAddress.country,
                        state: this.existingAddress.state,
                        city: this.existingAddress.city,
                        postcode: this.existingAddress.postcode,
                        remark: this.existingAddress.remark,
                    };

                    let customFieldValues = {};
                    Object.values(this.customFields).forEach((field) => {
                        customFieldValues[field.slug] = this.existingAddress.custom_fields?.[field.slug]?.value ?? null;
                    });
                    this.newAddressCustomFields = customFieldValues;
                }
            }
            this.errors = {};
        },
    },
    methods: {
        resetVariables() {
            let customFieldValues = {};

            this.newAddress = {
                label: "",
                phone: "",
                email: "",
                address_1: "",
                address_2: "",
                country: "",
                state: "",
                city: "",
                postcode: "",
                remark: "",
            };

            Object.values(this.customFields).forEach((field) => {
                customFieldValues[field.slug] = "";
            });
            this.newAddressCustomFields = customFieldValues;
        },

        triggerAction() {
            if (Object.values(this.mandatoryFields).length > 0) {
                Object.values(this.mandatoryFields).forEach((mandatoryField) => {
                    if (this.newAddress[mandatoryField].trim() == "") {
                        this.$set(
                            this.errors,
                            "shipping_address_" + mandatoryField,
                            this.generalTranslations.field_required
                        );
                    } else if (mandatoryField === "country" && this.newAddress[mandatoryField].trim().length < 2) {
                        this.$set(this.errors, "shipping_address_" + mandatoryField, this.translations.too_short);
                    } else if (mandatoryField !== "country" && this.newAddress[mandatoryField].trim().length < 3) {
                        this.$set(this.errors, "shipping_address_" + mandatoryField, this.translations.too_short);
                    } else {
                        this.$set(this.errors, "shipping_address_" + mandatoryField, "");
                    }
                });
            }

            const custom_fields = Object.keys(this.newAddressCustomFields).map((slug) => {
                if (this.mandatoryCustomFields) {
                    if (this.newAddressCustomFields[slug] == "" || this.newAddressCustomFields[slug] == null) {
                        this.$set(this.errors, slug, this.generalTranslations.field_required);
                    } else {
                        this.$set(this.errors, slug, "");
                    }
                }

                return {
                    slug: slug,
                    value: this.newAddressCustomFields[slug],
                };
            });

            const allEmpty = Object.values(this.errors).every((val) => val === "");

            if (allEmpty) {
                this.$emit("deactivate");
                this.$emit("trigger", {
                    label: this.newAddress["label"],
                    first_name: this.newAddress["label"],
                    phone: this.newAddress["phone"],
                    email: this.newAddress["email"],
                    address_1: this.newAddress["address_1"],
                    address_2: this.newAddress["address_2"],
                    country: this.newAddress["country"],
                    state: this.newAddress["state"],
                    city: this.newAddress["city"],
                    postcode: this.newAddress["postcode"],
                    remark: this.newAddress["remark"],
                    custom_fields: custom_fields,
                });
                this.resetVariables();
            }
        },
    },
};
</script>
